import { render, staticRenderFns } from "./StockRevisionDialogButton.vue?vue&type=template&id=3b3bc568&"
import script from "./StockRevisionDialogButton.vue?vue&type=script&lang=ts&"
export * from "./StockRevisionDialogButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports